import { PageProps } from "@/types/page";
import { usePage } from "@inertiajs/react";
import { formatInTimeZone } from "date-fns-tz";
import {
    BLOCKED_TIMES_CONTAINER_ID,
    BlockedTimesByDay,
    blockerKey,
} from "./dateTimePickerUtils";

type BlockedTimesProps = {
    blockedTimes: BlockedTimesByDay[number];
};

export default function BlockedTimes({ blockedTimes }: BlockedTimesProps) {
    const { user } = usePage<PageProps>().props;
    const userTimezone = user?.timezone ?? "UTC";

    return (
        <div id={BLOCKED_TIMES_CONTAINER_ID} className="flex flex-col gap-2">
            <div>
                <div
                    data-testid="blocked-times-heading"
                    className="flex text-lg font-bold"
                >
                    Your schedule
                </div>
            </div>
            <div className="flex flex-col gap-2">
                {blockedTimes.length > 0 ? (
                    blockedTimes.map((blockedTime) => (
                        <div
                            key={blockerKey(blockedTime)}
                            data-testid="blocked-time"
                            data-blocker-key={blockerKey(blockedTime)}
                            className="flex flex-col w-full rounded-lg border border-brand-border p-2 data-highlighted:border-brand-dangerOrange data-highlighted:bg-brand-dangerOrange/10"
                        >
                            <div className="text-sm text-brand-gray">
                                {formatInTimeZone(
                                    blockedTime.start,
                                    userTimezone,
                                    "h:mm a",
                                )}
                                {" - "}
                                {formatInTimeZone(
                                    blockedTime.end,
                                    userTimezone,
                                    "h:mm a",
                                )}
                            </div>
                            <div className="text-brand-black font-medium">
                                {blockedTime.name}
                            </div>
                            {blockedTime.source && (
                                <div className="text-sm text-brand-gray">
                                    {blockedTime.source === "appointment" ? (
                                        "From your appointments"
                                    ) : blockedTime.source === "time_off" ? (
                                        <div>
                                            From your{" "}
                                            <a
                                                href={route(
                                                    "coach.availability",
                                                    { step: 3 },
                                                )}
                                                target="_blank"
                                                className="text-brand-red underline"
                                            >
                                                time off & holidays
                                            </a>
                                        </div>
                                    ) : blockedTime.source === "external" ? (
                                        <div>
                                            From your{" "}
                                            <a
                                                href={route(
                                                    "coach.availability",
                                                    { step: 1 },
                                                )}
                                                target="_blank"
                                                className="text-brand-red underline"
                                            >
                                                connected calendars
                                            </a>
                                        </div>
                                    ) : null}
                                </div>
                            )}
                        </div>
                    ))
                ) : (
                    <div className="text-brand-gray">
                        Your schedule is empty for this day.
                    </div>
                )}
            </div>
        </div>
    );
}
